/**
 * @fileoverview GET handler for the "/analytics_dashboard/:app_group_id/agent_console_credit_consumption_detail_data" endpoint
 */
import { isAgentConsoleConsumptionResult } from "@dashboardApi/apis/agentConsoleConsumption/validators";

import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { agentConsoleConsumption } from "./constants";
import type { AgentConsoleConsumptionParams, AgentConsoleConsumptionResult } from "./types";

export const getDataTableAgentConsoleConsumption = reactQueryTableFetcherAdapter(
  agentConsoleConsumption,
  (
    signal: AbortSignal,
    { appGroupId, query, groupby, limit = 20, start = 0, sortdir, sortby }: AgentConsoleConsumptionParams
  ): Promise<AgentConsoleConsumptionResult> => {
    const {
      start_date,
      end_date,
      app_group: appGroup,
      agent_name: agentName,
      model_owner: modelOwner,
    } = query ?? {};

    return fetch(
      `/analytics_dashboard/${appGroupId}/agent_console_credit_consumption_detail_data`,
      "GET",
      {
        groupby,
        limit,
        sortby,
        sortdir,
        start,
        app_group_id: appGroupId,
        start_date: start_date,
        end_date: end_date,
        query: serializeQueryObjects({
          ...(appGroup && { app_group: appGroup }),
          ...(agentName && { agent_name: agentName }),
          ...(modelOwner && { model_owner: modelOwner }),
        }),
      },
      { signal }
    );
  },
  isAgentConsoleConsumptionResult
);
